import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import './Client.css';
import axios from "axios";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import Profile from "../Profile/Profile";
import { toast, ToastContainer } from "react-toastify";

import Breadcrumb from "../Breadcrumb";
import MetaHelmet from "../MetaHelmet";

const ClientIndex = () => {
  const [leads, setLead] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Client", path: "/client" },
  ];

  const leadStatusOptions = {
    1: "New",
    2: "Contacted",
    3: "Interested",
    4: "Converted",
  };

  const serviceInterestOptions = {
    1: "Website",
    2: "Google Listing",
    3: "E-Commerce",
  };
  // useEffect(() => {
  //   const fetchLeads = async () => {
  //     const token = localStorage.getItem("token");

  //     if (!token) {
  //       navigate("/");
  //       return;
  //     }
  //     try {
  //       const response = await axios.get(`${API_BASE_URL}get-leads/1`, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });

  //       if (Array.isArray(response.data.leads)) {
  //         setLead(response.data.leads);
  //       } else {
  //         setLead([]);
  //         console.error("Response data.leads is not an array");
  //       }
  //     } catch (err) {
  //       setError("Failed to fetch leads data. Please try again.");
  //       console.error(err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchLeads();
  // }, []);


  const fetchLeads = async (query = "") => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/");
      return;
    }
    try {
      const response = await axios.get(
        `${API_BASE_URL}get-leads/1?search=${query}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { search: searchTerm },
        }
      );

      if (Array.isArray(response.data.leads)) {
        setLead(response.data.leads);
      } else {
        setLead([]);
        console.error("Response data.leads is not an array");
      }
    } catch (err) {
      setError("Failed to fetch leads data. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, [searchTerm, API_BASE_URL, navigate]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchTerm(query);
    fetchLeads(query);
  };

  const handleEdit = (id) => {
    navigate(`/client/update/${id}`);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    try {
      await axios.delete(`${API_BASE_URL}delete-lead/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLead(leads.filter((lead) => lead.id !== id));
      toast.success("Client deleted Successfully");
    } catch (error) {
      setError("Error deleting lead. Please try again.");
      console.error("Error deleting lead:", error);
    }
  };

  if (loading) {
    return (
      <div id="loader-wrapper">
        <span className="loader"></span>
      </div>
    );
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <>
      <MetaHelmet title={`Local Shouts | Client`} />
      <div className="container">
        <Breadcrumb routes={routes} />
        <div className="d-flex bg-white p-3 rounded-2 white-box-shadow">
          <div class="form-group search-bar">
            <input
              type="text"
              placeholder="Search by client name"
              value={searchTerm}
              onChange={handleSearch}
              class="form-control bg-light-gray"
            />

          </div>
          <div className="input-reset-div py-1 px-2 ms-3" onClick={() => setSearchTerm('')}>
            <svg fill="#000000" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" class="input-reset">
              <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" fill-rule="evenodd" />
            </svg>
          </div>
          <div className="action-bar ms-auto">
            <Link to="/client/create" className="btn ls-btn main-btn create-btn">
              <FaPlus /> Create
            </Link>
          </div>
          <ToastContainer />
        </div>

        <div class="mt-5">
          {leads.length === 0 ? (
            <p>No leads found</p>
          ) : (
            <table class="table table-hover rounded-table white-box-shadow">
              <thead>
                <tr>
                  <th>Business Name</th>
                  <th>Contact Name</th>
                  <th>Business Address</th>
                  <th>Service Interest</th>
                  <th>Lead Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {leads.map((lead) => (
                  <tr key={lead.id}>
                    <td>{lead.business_name}</td>
                    <td>{lead.contact_name}</td>
                    <td>{lead.bussiness_address}</td>
                    <td>{serviceInterestOptions[lead.service_interest] || "N/A"}</td>
                    <td>{leadStatusOptions[lead.lead_status] || "Unknown"}</td>
                    <td>
                      <button
                        className="btn btn-primary"
                        onClick={() => handleEdit(lead.id)}>
                        <FaEdit />
                      </button>
                      <button
                        className="btn btn-danger ms-2"
                        onClick={() => handleDelete(lead.id)}>
                        <FaTrashAlt />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <Profile setLead={setLead} />
      </div>
    </>
  );
};

export default ClientIndex;
